<template>
  <div id="app">
    <div>
      <bgl-nav />
      <router-view />
      <footer class="footer">
        <div class="content has-text-centered">
          <router-link to="/termsofuse">Terms of Use</router-link>&nbsp; &nbsp; 
          <router-link to="/privacynterms">Privacy Policy</router-link>
          <p><img class="logo" src="https://storage.googleapis.com/bluegiraffelabs_web/blue_giraffe_labs_logo.png" width=150px></p>
          <!-- <p></p> -->
          <p style="font-size:10px;">{{ new Date().getFullYear() }}  &copy; BlueGiraffeLabs. All rights reserved.</p>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import Nav from '@/components/Nav.vue';

export default {
  name: 'App',
  components: {
    'bgl-nav': Nav
  },
  methods: {
    goPrivacyNTerms() {
      this.$router.push('/privacynterms').catch({});
    }
  }
}
</script>

<style>
body {
  overflow: hidden;
}

body::-webkit-scrollbar {
  display: none;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}

</style>
